/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'shared';
const componentName = 'full-modal-config-viewer';
const prefix = `${moduleName}.${componentName}`;

export const viewAsJson = `${prefix}.viewAsJson`;
export const review = `${prefix}.review`;

export const ENGLISH = {
    [viewAsJson]: 'View as JSON',
    [review]: 'Review',
};
